import PropTypes from "prop-types"
import React from "react"

import { AnimatedModal } from "./Modal"
import Typography from "./Typography"

/**
 * Second-step confirmation before capturing a client's card on file (manual charge flows).
 */
const ConfirmManualChargeModal = ({
  visible,
  hideModal,
  onConfirm,
  clientName,
  amountLabel,
  chargeSummary,
  cardBrand,
  cardLast4,
  confirmLoading = false,
  header = "Confirm charge"
}) => {
  const displayName = clientName || "This client"
  const cardDescription =
    cardBrand && cardLast4 ? (
      <>
        {cardBrand} ending in {cardLast4}
      </>
    ) : (
      "the card on file"
    )

  return (
    <AnimatedModal
      visible={visible}
      hideModal={hideModal}
      header={header}
      showFooter={true}
      cancelButtonCopy="Cancel"
      actionButtonCopy={confirmLoading ? "Charging…" : `Charge ${amountLabel} now`}
      saveDisabled={confirmLoading}
      onSave={onConfirm}>
      <Typography variant="body" className="text-gray-dark">
        You are about to charge <strong>{displayName}</strong>&apos;s {cardDescription} for{" "}
        <strong>{amountLabel}</strong>
        {chargeSummary ? (
          <>
            {" "}
            for <strong>{chargeSummary}</strong>
          </>
        ) : null}
        . The charge will be processed immediately. If you need to refund later, use{" "}
        <strong>Add refund/adjustment</strong> on this appointment (after it is paid) or from the client&apos;s billing
        page.
      </Typography>
    </AnimatedModal>
  )
}

ConfirmManualChargeModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  clientName: PropTypes.string,
  amountLabel: PropTypes.string.isRequired,
  chargeSummary: PropTypes.string,
  cardBrand: PropTypes.string,
  cardLast4: PropTypes.string,
  confirmLoading: PropTypes.bool,
  header: PropTypes.string
}

export default ConfirmManualChargeModal
